import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import {
  HeadingDisplay,
  FilterSelect,
  SkeletonLoader
} from '@warrenbrasil/nebraska-web';

import {
  PortfolioPerformanceResponse,
  PortfolioPerformanceFilterOption
} from '@/modules/wealth/services/portfolio';
import { HeadingDisplayLoader } from '@/modules/trade/components/HeadingDisplayLoader';
import { PerformanceFetchingStatus } from '../../types';

interface Props {
  performanceData?: PortfolioPerformanceResponse | null;
  selectedYear?: string | number | null;
  status: PerformanceFetchingStatus;
}
interface Emit {
  (e: 'on-change-year', year: string | number): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PerformanceHeader',
  props: {
    performanceData: null,
    selectedYear: null,
    status: null
  },
  emits: ["on-change-year"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'on-change-year', year: string | number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  performanceData?: PortfolioPerformanceResponse | null;
  selectedYear?: string | number | null;
  status: PerformanceFetchingStatus;
};





const shouldRenderLoadingState = computed(() => {
  return (
    props.status === PerformanceFetchingStatus.Loading && !props.performanceData
  );
});

const hasYearsOptions = computed(() => {
  return yearsOptions.value.length > 0;
});

const yearsOptions = computed(() => {
  return props.performanceData?.filters?.years.map(formatFilterOption) || [];
});

const portfolioName = computed(() => {
  return props.performanceData?.portfolio?.name || '-';
});

const updatedAt = computed(() => {
  return props.performanceData?.updatedAt?.formatted || '-';
});

const handleChangeYear = (value: string | number) => {
  emit('on-change-year', value);
};

const formatFilterOption = (option: PortfolioPerformanceFilterOption) => {
  return {
    value: option.value,
    label: String(option.label)
  };
};

return { __sfc: true,props, emit, shouldRenderLoadingState, hasYearsOptions, yearsOptions, portfolioName, updatedAt, handleChangeYear, formatFilterOption, HeadingDisplay, FilterSelect, SkeletonLoader, HeadingDisplayLoader }
}

})